<template>
  <div
    class="fixed vh-100"
    style="width: 100vw;"
    ref="leafContainer"
  >
    <transition
      @enter="animLeaves"
      @leave="animLeavesOut"
    >
      <simple-svg
        v-show="trigger"
        v-if="position[0]"
        ref="leaf1"
        :filepath="leaves"
        class="leaf top-left absolute w-50"
        style="transform: rotate(0deg)"
      />
    </transition>
    <transition
      @enter="animLeaves"
      @leave="animLeavesOut"
    >
      <simple-svg
        v-show="trigger"
        v-if="position[1]"
        ref="leaf2"
        :filepath="leaves"
        class="leaf top-right absolute w-50"
        style="transform: rotate(90deg)"
      />
    </transition>
    <transition
      @enter="animLeaves"
      @leave="animLeavesOut"
    >
      <simple-svg
        v-show="trigger"
        v-if="position[2]"
        ref="leaf3"
        :filepath="leaves"
        class="leaf bottom-right absolute w-50"
        style="transform: rotate(180deg)"
      />
    </transition>
    <transition
      @enter="animLeaves"
      @leave="animLeavesOut"
    >
      <simple-svg
        v-show="trigger"
        v-if="position[3]"
        ref="leaf4"
        :filepath="leaves"
        class="leaf bottom-left absolute w-50"
        style="transform: rotate(270deg)"
      />
    </transition>
  </div>
</template>

<script>
import gsap from 'gsap'
import transitions from '../transitions.js'
export default {
  name: 'BgLeaves',
  data () {
    return {
      leaves: require('@/assets/img/bg.svg')
    }
  },
  props: {
    trigger: {
      type: Boolean,
      default: false
    },
    position: {
      type: Array,
      default: null
    },
    inset: {
      type: Number,
      default: 0
    }
  },
  mounted () {
  },
  computed: {
    // foliage () {
    //   let foliage = []
    //   for (let i = 0; i < 4; i++) {
    //     foliage.push(this.$refs.leaf[i])
    //   }
    //   return foliage
    // }
  },
  methods: {
    animLeaves (el, done) {
      const cls = el.classList
      switch (true) {
        case cls.contains('top-left'):
          transitions.leafTopLeft(el, done, this.inset)
          break
        case cls.contains('top-right'):
          transitions.leafTopRight(el, done, this.inset)
          break
        case cls.contains('bottom-right'):
          transitions.leafBottomRight(el, done, this.inset)
          break
        case cls.contains('bottom-left'):
          transitions.leafBottomLeft(el, done, this.inset)
          break
      }
    },
    animLeavesOut (el, done) {
      const foliage = this.$refs.leafContainer.querySelectorAll('svg')
      gsap.fromTo(foliage,
        {
          opacity: 1
        },
        {
          opacity: 0,
          duration: 0.3,
          onComplete: done
        }
      )
    }
  }
}

</script>
